import moment from 'moment'

import {BUSINESS_HOURS_CANCELLATION_CUT_OFF_TIME_THRESHOLD} from '../../OrderIntake/declarations/constants'

import {CancellationTimeWindow} from './types'

export const calculateCancellationTimeWindow = (
  cancellableUntil: string | undefined,
  timerThreshold: string | undefined,
  nowProvider: () => moment.Moment
): CancellationTimeWindow => {
  if (!cancellableUntil) {
    return {isCancellable: false, isTimerActive: false}
  }

  const now = nowProvider()
  const until = moment.utc(cancellableUntil)
  const thresholdDuration = moment.duration(
    timerThreshold ?? BUSINESS_HOURS_CANCELLATION_CUT_OFF_TIME_THRESHOLD
  )
  const thresholdStart = until.clone().subtract(thresholdDuration)

  const isCancellable = now.isBefore(until)
  const isTimerActive = now.isBetween(thresholdStart, until)

  const remainingTime = moment.duration(until.diff(now))
  const timer = isTimerActive
    ? {
        isTimerActive,
        timer: {
          hours: remainingTime.hours(),
          minutes: remainingTime.minutes(),
          seconds: remainingTime.seconds()
        }
      }
    : {isTimerActive}

  return {isCancellable, cancellableUntil: until, ...timer}
}
